import '../../styles/game/howToPlay.css'
import { useTranslation } from "react-i18next";
import { useEffect, useState } from 'react';

function howToPlay({ isOpen, onClose, GameRulesOpen }) {
    const [isVisible, setIsVisible] = useState(false);
    const { t } = useTranslation();
    useEffect(() => {
        if (isOpen) {
            setTimeout(() => setIsVisible(true), 10);

        } else {
            setIsVisible(false);

        }
    }, [isOpen]);


    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Escape') {
                setTimeout(() => setIsVisible(false), 10);
                onClose();
            }
        };

        document.addEventListener("keydown", handleKeyDown);
        return () => document.removeEventListener("keydown", handleKeyDown);
    }, [onClose]);


    return (
        <>
        <div className={`modalWrapper ${isVisible ? "show" : "fade-out"}`}
             onClick={() => {
                 setTimeout(() => setIsVisible(false), 10);
                 onClose();
             }} >
        </div>
        <div className={`howtoplay-modal-wrapper ${isVisible ? "show" : "fade-out"}`} onClick={() => {
            setTimeout(() => setIsVisible(false), 10);
            onClose();
        }}>
            <div className={`hwt-wrap ${isVisible ? "show" : "fade"}`}>
                <div className={"hwt-content-wrap"} onClick={(e) => e.stopPropagation()}>
                    <div className={"hwt-header"}>
                        <span>{t("howToPlayComponent.howToPlay").toUpperCase()}</span>
                        <button className={"hwt-close-btn"} onClick={() => {
                            setTimeout(() => setIsVisible(false), 10);
                            onClose();
                        }}>
                            <span className={"hwt-x"}>×</span>
                        </button>
                    </div>
                    <div className={"hwt-body"}>
                        <div className={"youtube-embed"}>
                            <iframe src="https://www.youtube.com/embed/PZejs3XDCSY"
                                    title="Spribe Aviator - How to play?" frameBorder="0"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                    referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
                        </div>
                        <div className={"step"}>
                            <div className={"step-title-wrap"}>
                                <p>01</p>
                                <img src={"/assets/img/01-bet.svg"}/>
                            </div>
                            <div className={"step-context"}>
                                <p>{t("howToPlayComponent.step01")}</p>
                            </div>
                        </div>
                        <div className={"step"}>
                            <div className={"step-title-wrap"}>
                                <p>02</p>
                                <img src={"/assets/img/02-watch.svg"}/>
                            </div>
                            <div className={"step-context"}>
                                <p>{t("howToPlayComponent.step02")}</p>
                            </div>
                        </div>
                        <div className={"step"}>
                            <div className={"step-title-wrap"}>
                                <p>03</p>
                                <img src={"/assets/img/03-cashout.svg"}/>
                            </div>
                            <div className={"step-context"}>
                                <p>{t("howToPlayComponent.step03")}</p>
                            </div>
                        </div>
                    </div>
                    <div className={"hwt-footer"}>
                        <button className={"detail-rules"} onClick={() => {
                            setTimeout(() => setIsVisible(false), 10);
                            onClose();
                            GameRulesOpen();
                        }}>
                            {t("howToPlayComponent.detailedRules")}
                        </button>
                    </div>
                </div>
            </div>
        </div>
        </>
    )
}

export default howToPlay;